import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceAlerts = () => {
  const [alerts, setAlerts] = useState([
    {
      id: 1,
      severity: 'success',
      title: 'Revenue Target Exceeded',
      message: 'Monthly collections are 4.1% above target. Excellent performance!',
      timestamp: '2 hours ago',
      dismissible: true
    },
    {
      id: 2,
      severity: 'warning',
      title: 'No-Show Rate Increasing',
      message: 'No-show rate has increased to 6.4% this week. Consider implementing reminder protocols.',
      timestamp: '5 hours ago',
      dismissible: true
    },
    {
      id: 3,
      severity: 'info',
      title: 'Benchmark Comparison Available',
      message: 'New industry benchmark data is available for Q1 2026. Review performance metrics.',
      timestamp: '1 day ago',
      dismissible: true
    }
  ]);

  const getSeverityStyles = (severity) => {
    switch (severity) {
      case 'success':
        return {
          bg: 'bg-success/10',
          border: 'border-success/20',
          icon: 'CheckCircle',
          iconColor: 'text-success'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          border: 'border-warning/20',
          icon: 'AlertTriangle',
          iconColor: 'text-warning'
        };
      case 'info':
        return {
          bg: 'bg-primary/10',
          border: 'border-primary/20',
          icon: 'Info',
          iconColor: 'text-primary'
        };
      default:
        return {
          bg: 'bg-muted',
          border: 'border-border',
          icon: 'Bell',
          iconColor: 'text-muted-foreground'
        };
    }
  };

  const handleDismiss = (alertId) => {
    setAlerts(alerts?.filter((alert) => alert?.id !== alertId));
  };

  if (alerts?.length === 0) return null;

  return (
    <div className="space-y-3">
      {alerts?.map((alert) => {
        const styles = getSeverityStyles(alert?.severity);
        return (
          <div
            key={alert?.id}
            className={`${styles?.bg} border ${styles?.border} rounded-lg p-4 flex items-start gap-3`}
          >
            <div className={`flex-shrink-0 ${styles?.iconColor}`}>
              <Icon name={styles?.icon} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-foreground mb-1">{alert?.title}</h3>
                  <p className="text-sm text-muted-foreground">{alert?.message}</p>
                </div>
                {alert?.dismissible && (
                  <button
                    onClick={() => handleDismiss(alert?.id)}
                    className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors"
                    aria-label="Dismiss alert"
                  >
                    <Icon name="X" size={16} />
                  </button>
                )}
              </div>
              <p className="text-xs text-muted-foreground mt-2">{alert?.timestamp}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PerformanceAlerts;